template>
<div>
    <a @click="triggerSend(0)">Send 1</a>
    <a @click="triggerSend(1)">Send 2</a>
    <a @click="triggerSend(2)">Send 3</a>
</div>
</template>

<script>
  /* eslint-disable no-alert, no-console */
  export default {
    name: 'Support',
    data: function () {
      return {
        data: [
          {
            'email': 'luke.holtham@microba.com',
            'firstName': 'Luke',
            'lastName': 'Holtman',
            'qty': 3,
            'stripeID': 'abcd',
            'amount': 300,
            'description': '1 Kits purchased'
          },
          {
            'email': 'Danny.bosch@microba.com',
            'firstName': 'Danny',
            'lastName': 'bosch',
            'qty': 5,
            'stripeID': 'abcd',
            'amount': 600,
            'description': '2 Kits purchased'
          },
          {
            'email': 'neville+person3@cubehq.com.au',
            'firstName': 'Person',
            'lastName': 'Three',
            'qty': 3,
            'stripeID': 'abcde',
            'amount': 900,
            'description': '3 Kits purchased'
          }
        ]
      }
    },
    methods: {
      triggerSend: function (i) {
        this.queryAPI(
            this.data[i]['email'],
            this.data[i]['firstName'],
            this.data[i]['lastName'],
            this.data[i]['qty'],
            this.data[i]['stripeID'],
            this.data[i]['amount'],
            this.data[i]['description'],
        )
      },
      queryAPI (email, firstName, lastName, qty, stripeID, amount, description) {
        let kitDtos = [{}]
        for (let i = 1; i < qty; i++) {
          kitDtos.push({})
        }
        let dateTime = (new Date()).getTime()
        let payload = {
          'purchaserEmail': email,
          'purchaserFirstName': firstName,
          'purchaserLastName': lastName,
          'orderType': 'NEW',
          'paymentId': stripeID,
          'amount': amount,
          'description': description,
          'created': dateTime,
          'kitDtos': kitDtos
        }
        this.$store.dispatch('postOrder', payload).then(success => {
          console.log('Created', payload)
        }).catch(error => {
          console.log('Failed', payload, error)
        })
      }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/application/customer/Send.vue